"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ForeignObject = _styled["default"].foreignObject(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin: 0;\n  padding: 0;\n"])));

var Wrap = _styled["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  flex: 1;\n  color: #171717;\n  font-size: 12px;\n"])));

var YAxisArrow = function YAxisArrow(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    x: "0",
    y: "-26"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/_react["default"].createElement(ForeignObject, {
    width: "52",
    height: "33",
    x: "20",
    y: "9"
  }, /*#__PURE__*/_react["default"].createElement(Wrap, null, children))));
};

YAxisArrow.propTypes = {
  children: _propTypes["default"].node.isRequired
};
var _default = YAxisArrow;
exports["default"] = _default;